module.exports = __webpack_public_path__ + "img/BT_Back.f1a2a05c.svg";